import amplitude from "amplitude-js";

amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_ID); // initializes default instance of Amplitude client

export default amplitude;
